// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { addSecuritiesInfo } from './securities-info.actions';
export const securitiesInfo = createReducer({}, on(addSecuritiesInfo, (state, action) => {
    const newInfo = {};
    action.securitiesInfo.forEach((item) => {
        newInfo[item.id] = {
            display_security_id: item.display_security_id,
            feature_needed: item.feature_needed,
            security_name: item.security_name,
        };
    });
    return { ...state, ...newInfo };
}));
